import Delay from '../utils/Delay';
import axios from 'axios';
import {environment} from '../environment/environment';
import { baseEnvironment } from '../environment/environment.base';


const successRes = {
  status: true
};
const failureRes = {
  message: 'USER_LOGIN_FAILURE',
  status: false
};
const loginUrl = `/${baseEnvironment.apiVersion1}${environment.apiEndPoints.auth.loginUrl}`;
const azureSSOLogin = `/${baseEnvironment.apiVersion1}${environment.apiEndPoints.auth.azureSSOLogin}`;
const userLogoutUrl = `/${baseEnvironment.apiVersion1}${environment.apiEndPoints.userLogoutUrl.userLogoutUrl}`;
// const userUrl = '/v1/user/me';

// How long to wait for fake async action to complete
const delayMs = 1000;

export const loginService = async (values: any): Promise<any> => {
  const response = await axios.post(loginUrl, values);
  return response.data;
};

export const loginAzureSSOService = async (
  accessToken: any,
  refreshToken: any,
  idToken: any,
  admin: boolean
): Promise<any> => {
  try {
    const values = {
      access_token: accessToken,
      refresh_token: refreshToken,
      id_token: idToken,
      admin
    };
    const response = await axios.post(azureSSOLogin, values);
    return response.data;
  } catch (error) {
    return {error, azureSSOLogin};
  }
};

export const userLogout = async (azureId: any): Promise<any> => {
  try {
    const response = await axios.post(userLogoutUrl + `/` + azureId);
    return response.data;
  } catch (error) {
    return {error, userLogoutUrl};
  }
};

export const logoutService = async (values: any): Promise<any> => {
  await Delay(delayMs);
  return successRes;
};

export const registerService = async (values: any): Promise<any> => {
  await Delay(delayMs);
  return failureRes;
};

export const forgotPasswordService = async (values: any): Promise<any> => {
  await Delay(delayMs);
  return successRes;
};
